import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    expire: ''
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      localStorage.setItem("token", token)
    },
    SET_EXPIRE: (state, expire) => {
      state.expire = expire
      localStorage.setItem("expire", expire)
    }
  },
  modules: {
  }
})
